export * from "./inflate-booking-location-presenter";

// https://stackoverflow.com/questions/38655711/export-a-typescript-class-from-another-file-than-it-has-been-defined-in
import { BookingLocationPresenter as MyBookingLocationPresenter } from "./booking-location-presenter";
export type BookingLocationPresenter = MyBookingLocationPresenter;
export const BookingLocationPresenter = MyBookingLocationPresenter;
